<!--
 * @Author: chenxing
 * @LastEditors: chenxing
-->
<template>
  <a-spin :spinning="logining">
    <div class="container" :style="{ backgroundImage: `url(${require('@/assets/image/login-bg.png')})` }">
      <div class="login-form" :class="{ is_moblie: isMobile }">
        <div class="login-content">
          <div class="left">
            <img class="left-bg" src="@/assets/image/login-left.png" />
          </div>
          <div class="right">
            <div class="login_info">
              <img class="logo" src="@/assets/image/logo.png" alt="logo" />
              <div class="login-title">欢迎使用{{ sysName }}</div>
              <div class="login-subtitle">请使用飞书账号登录</div>
              <button type="button" class="feishu-btn" aria-label="打开飞书授权窗口" @click="feishuLogin()">
                <img class="feishu-btn-logo" src="@/assets/image/logo_feishu.png" alt="飞书" />
                飞书授权登录
              </button>
              <p class="login-tip">点击后将打开飞书授权窗口，授权成功后自动登录</p>
              <!-- 账号密码登录暂不开放，保留代码便于后续恢复
              <span class="span">账号</span>
              <a-input class="input shadow-none border-none" placeholder="请输入账号" v-model:value="username">
                <template #prefix>
                  <svg-icon icon-class="user" class-name="menu_icon" />
                </template>
              </a-input>
              <span class="span">密码</span>
              <a-input-password class="input shadow-none border-none" placeholder="请输入密码" v-model:value="password" type="password" @keydown="onPwdInputKeydown" autocomplete>
                <template #prefix>
                  <svg-icon icon-class="password"></svg-icon>
                </template>
              </a-input-password>
              <div class="btn_wrapper" style="width: 100%">
                <a-button class="btn-login" type="primary" shape="round" @click="loginFn()">登录</a-button>
                <a-button class="btn-reset" type="default" shape="round" @click="loginReset()">重置</a-button>
              </div>
              <a-divider>第三方平台登录</a-divider>
              <div class="third-login">
                <a-button shape="round" @click="feishuLogin()">
                  <template #icon>
                    <img src="@/assets/image/logo_feishu.png" class="feishu-logo" />
                    飞书
                  </template>
                </a-button>
              </div>
              -->
            </div>
          </div>
        </div>
        <div class="login-footer">©2021 Titan Intelligent Advertising System</div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import defaultSettings from '@/config/defaultSettings';
// import { setCookie, getCookie } from '@/utils/cookie.js';

export default {
  data: function () {
    return {
      sysName: defaultSettings.sysName,
      sysNameEN: defaultSettings.sysNameEN,
      // username: '',
      // password: '',
      logining: false,
    };
  },
  created() {
    // 回调页与登录页同源部署(生产均为 tias.plus);dev 因 redirect_uri 固定为生产域名流程不通,校验逻辑按同源判断即可
    this.feishuMessageHandler = event => {
      if (event.origin !== window.location.origin) return;
      if (typeof event.data !== 'string') return;
      // event.data 是弹出回调页 postMessage 过来的消息
      let strs = event.data.split('?');
      if (strs[0] == 'feishu_login_success') {
        this.feishu_login_success();
      }
    };
    window.addEventListener('message', this.feishuMessageHandler, false);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.feishuMessageHandler);
  },
  methods: {
    // 账号密码登录暂不开放，保留代码便于后续恢复
    // onPwdInputKeydown(key) {
    //   if (key.key === 'Enter') {
    //     this.loginFn();
    //   }
    // },
    // loginFn() {
    //   sessionStorage.clear();
    //   if (!getCookie('access_token')) {
    //     setCookie('access_token', this.username, 7);
    //   }
    //   let param = {
    //     username: this.username,
    //     password: this.password,
    //   };
    //   this.logining = true;
    //   this.$store
    //     .dispatch('oauth/Login', param)
    //     .then(() => {
    //       this.$router.push(this.$route.query.redirect || '/');
    //     })
    //     .finally(() => {
    //       this.logining = false;
    //     });
    // },
    // loginReset() {
    //   this.username = '';
    //   this.password = '';
    // },
    feishuLogin() {
      // 不置 logining:弹窗可被用户随时取消,登录页需保持可操作,成败以回调页 postMessage 为准
      // redirect_uri 必须与飞书后台"安全设置-重定向URL"白名单完全一致
      window.open('https://www.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a1ec22112c391013&redirect_uri=https://tias.plus/oauth_feishu&response_type=code&state=thirdpartylogin', '_blank', 'width=500,height=650,top=100,left=600');
    },
    feishu_login_success() {
      // 弹窗回调页已完成 code 换登录态(session cookie 同域共享),此处拉取用户信息并跳转
      this.$store.dispatch('oauth/GetUserInfo').then(() => {
        this.$router.push(this.$route.query.redirect || '/');
      });
    },
  },
  computed: {
    isMobile() {
      const sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIphone = sUserAgent.match(/iphone os/i) == 'iphone os';
      let bIsAndroid = sUserAgent.match(/android/i) == 'android';
      return bIsIphone || bIsAndroid;
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  text-align: center;
  // width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;

  .login-form {
    position: relative;
    bottom: 200px;
    top: 0;
    margin: auto;
    width: 78%;
    min-width: 78%;
    height: 70%;
    min-height: 70%;
    border-radius: 15px;
    overflow: hidden;
    .login-content {
      display: flex;
      height: 100%;
      border-radius: 15px;
      overflow: hidden;
      background-image: url('~@/assets/image/login-form-bg.png');
      background-color: rgba(255, 255, 255, 0.99);
      background-size: cover;

      .left {
        position: relative;
        flex: 1;
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        .left-bg {
          width: 22.5rem;
          height: 15.8rem;
          position: relative;
          margin-top: 0.5rem;
        }
      }
      .right {
        position: relative;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .login_info {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 16px;
          width: 80%;
        }
        .logo {
          // width: 4.375rem;
          // height: 1.75rem;
          width: 140px;
          height: 56px;
        }
        .span {
          color: #000;
          display: block;
          text-align: left;
          width: 100%;
          margin-top: 1rem;
          margin-bottom: 0.375rem;
        }
        .input {
          background: #f2f4f8;
          border-radius: 8px;
          height: 48px;
          font-size: 16px;

          :deep(.ant-input) {
            background: #f2f4f8;
            font-size: 16px;
          }
        }
        .btn-login,
        .btn-reset {
          font-size: 14px;
          width: 100%;
          height: 48px;
          border-radius: 8px;
          margin-top: 26px;
        }
        .third-login {
          .feishu-logo {
            width: 0.5rem;
            height: 0.5rem;
            margin-right: 5px;
          }
        }
        .login-title {
          margin-top: 1.5rem;
          font-size: 20px;
          font-weight: 600;
          color: #1f2329;
          letter-spacing: 0.02em;
        }
        .login-subtitle {
          margin-top: 0.5rem;
          font-size: 14px;
          color: #646a73;
        }
        .feishu-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 2rem;
          width: 100%;
          height: 48px;
          font-size: 16px;
          font-weight: 500;
          color: #1f2329;
          background: #fff;
          border: 1px solid #dcdfe6;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;

          .feishu-btn-logo {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }

          &:hover,
          &:focus-visible {
            color: #2f70f4;
            border-color: rgba(47, 112, 244, 0.5);
            box-shadow: 0 6px 20px rgba(47, 112, 244, 0.12);
            outline: none;
          }
        }
        .login-tip {
          margin: 0.75rem 0 0;
          font-size: 12px;
          color: #8f959e;
        }
        @media (prefers-reduced-motion: reduce) {
          .feishu-btn {
            transition: none;
          }
        }
      }
    }

    .login-footer {
      font-size: 0.5rem;
      color: #fff;
      position: relative;
      top: 1em;
    }
  }
}
// 手机端显示效果
.is_moblie {
  min-height: 390px !important;
  .login-content {
    height: 80% !important;
    .left {
      display: none !important;
    }
    .login_info {
      .logo {
        height: 40px !important;
        width: auto !important;
      }
      .login-title {
        margin-top: 12px;
        font-size: 18px;
      }
      .login-subtitle {
        margin-top: 6px;
      }
      .feishu-btn {
        height: 40px;
        margin-top: 16px;
        font-size: 15px;
      }
      .span {
        margin-top: 12px !important;
        margin-bottom: 0;
      }
      .input {
        height: 40px !important;
        font-size: 16px;
        :deep(.ant-input) {
          background: #f2f4f8;
          font-size: 16px;
        }
      }
      .btn_wrapper {
        display: flex;
        justify-content: space-between;
        .btn-login,
        .btn-reset {
          height: 40px !important;
          margin-top: 12px;
          width: 40% !important;
        }
      }
    }
  }
}
</style>